module.exports = __webpack_public_path__ + "sflyssofe.f8b12ee486.svg";